import styled, { keyframes } from "styled-components";
import { colors } from "../../../styles/colors";

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const pulseShadow = keyframes`
  0%, 100% {
    box-shadow: 0 8px 24px rgba(0, 78, 247, 0.35), 0 0 15px rgba(0, 234, 178, 0.25);
  }
  50% {
    box-shadow: 0 12px 32px rgba(0, 78, 247, 0.55), 0 0 25px rgba(0, 234, 178, 0.45);
  }
`;

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(40px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0) scale(1);
  }
`;

export const BannerContainer = styled.div<{ $hasNav: boolean }>`
  position: fixed;
  bottom: ${({ $hasNav }) => ($hasNav ? "94px" : "28px")};
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 24px;
  background: linear-gradient(271.58deg, #004ef7 0%, #00eab2 96.51%);
  border-radius: 100px;
  color: ${colors.white};
  font-family: 'Noto Sans Hebrew', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  font-weight: 600;
  direction: rtl;
  white-space: nowrap;
  pointer-events: auto;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.25);
  animation:
    ${slideUp} 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275),
    ${pulseShadow} 3s infinite ease-in-out;
  transition: bottom 0.3s ease, transform 0.3s ease;

  @media (max-width: 480px) {
    width: calc(100% - 32px);
    max-width: 380px;
    padding: 10px 18px;
    font-size: 13px;
    justify-content: center;
  }
`;

export const SpinnerIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.white};
  animation: ${spin} 1.2s linear infinite;

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const BannerContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .main-text {
    color: ${colors.white};
    font-weight: 700;
  }

  .sub-text {
    color: rgba(255, 255, 255, 0.92);
    font-size: 13px;
    font-weight: 500;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    
    .sub-text {
      font-size: 11px;
    }
  }
`;
